<template>
  <div class="MobileNavContainer">
    <!-- desktop navbar -->
    <div class="fixedNavBar">
      <div @click="goToHome()" class="flex">
        <img src="../assets/images/logo/logo1.png" class="logo" />
        <img :style="[currentEnvironment.width ? { width: currentEnvironment.width } : {}]" :src="currentEnvironment.logo" class="cursor-pointer navbar-logo broker-logo" style="margin-left: -80px" />
      </div>

      <div class="navbarContent">
        <!-- :class="{ 'publish-btn': isMarketPageActive }" -->
        <!-- <div class="cursor-pointer menu-links" @click="goToLink('/home')">HOME</div> -->

       <div
  v-if="userProfile && userProfile.profession != 'Retail Investor' && userProfile.profession != 'Dealer' && websiteUserType.userType != 'broker'"
  class="menu-links"
  :class="{ 'publish-btn': isMyChatActive }"
  @click="goToLink('/chat')"
>
  <span class="cursor-pointer">MY Chat</span>
</div>

        <div class="cursor-pointer menu-links right-margin-15"  v-if="userProfile && userProfile.profession == 'Retail Investor'" :class="{ 'publish-btn': isExpertChatListActive }" v-on:click="goToLink('/expert-list')">
          <!-- <span style="position: absolute">
            <img src="../assets/images/beta.svg" style="position: relative; bottom: 11px; left: 60px" alt="" />
          </span> -->
          EXPERT CHAT
        </div>

        <div class="cursor-pointer menu-links" :class="{ 'publish-btn': isPricingSectionActive }" v-on:click="goToLink('/pricing')" v-if="websiteUserType.userSubType != 'brokerWithoutPlans' && currentEnvironment.loginModule != 'BlinkX'">PLANS</div>
      </div>

      <div class="flex" style="justify-content: end" :style="websiteUserType.userType != 'broker' ? { width: '590px' } : { width: '720px' }" v-if="isUserLoggedIn">
        
        <div class="chat-btn" v-if="userProfile.profession == 'Retail Investor' && getChatPlanDetails && getChatPlanDetails.total_chat_session" @click="$router.push('/chat')">{{ getChatPlanDetails.total_chat_session == 1 ? '1 Chat' : getChatPlanDetails.total_chat_session + 'Chats' }}</div>  

        <div class="navbar-profile-pic-section">
          <el-dropdown trigger="click">
            <span class="el-dropdown-link cursor-pointer">
              <img :src="profile_pic" class="profile-pic" height="30" width="30" slot="reference" />
            </span>

            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item class="menu-bar-items" v-on:click.native="goToLink('/my-account')">My account</el-dropdown-item>
              <el-dropdown-item class="menu-bar-items" v-on:click.native="goToLink('/profile-update')">Profile</el-dropdown-item>

              <el-dropdown-item v-if="userProfile && userProfile.profession == 'Retail Investor'" class="menu-bar-items" v-on:click.native="goToLink('/chat')">Chat History</el-dropdown-item>
            
              <el-dropdown-item v-if="paytmSource != 'app' && !currentEnvironment.byPassLogin && currentEnvironment.loginModule != 'BlinkX' && !currentUrl.includes('almondz.stockants.com') && !currentUrl.includes('almondztrade.stockants.com') && !currentUrl.includes('findoc.stockants.com')" class="menu-bar-items" v-on:click.native="logOut()">Logout</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>

    <!-- mobile view navbar -->
    <div class="mobile-view-nav-container">
      <div class="mobileToggleMenuBtn" @click="toogleMobileSideNav" v-if="userProfile && userProfile.utm_source != 'Bigul' && !currentUrl.includes('bigul.stockants.com')">
        <div class="nav-icon">
          <div></div>
        </div>
      </div>
      <div class="flex-space-between" style="width: 95%">
        <div class="flex">
          <img @click="$router.push({ path: '/' })" src="../assets/images/logo/logo1.png" class="logo" style="width: 170px; margin-left: 5px" />
          <img :style="[currentEnvironment.width ? { width: currentEnvironment.width } : {}]" :src="currentEnvironment.logo" class="cursor-pointer navbar-logo broker-logo" style="margin-left: -80px" />
        </div>
        <div class="flex">
          <div class="chat-btn" v-if="userProfile.profession == 'Retail Investor' && getChatPlanDetails && getChatPlanDetails.total_chat_session">{{ getChatPlanDetails.total_chat_session == 1 ? '1 Chat' : getChatPlanDetails.total_chat_session + 'Chats' }}</div>
        </div>

      </div>

      <div class="footer-nav" style="overflow-y: scroll">
        <div class="footer-inner">
          <div class="sections cursor-pointer" v-if="currentEnvironment && currentEnvironment.byPassLogin">
            <i class="el-icon-back" @click="backToPrevious()" style="font-size: 21px"></i>
            <br />
            <p class="label menu-links">Back</p>
          </div>
          <div class="sections cursor-pointer" @click="$router.push('/equity-watchlist')" v-if="userProfile && userProfile.profession == 'Retail Investor' && ($route.path == '/experts-past-recommendations' || $route.path == '/data-categorisation' || $route.path == '/equity-watchlist')">
            <img src="./../assets/images/Watchlist (Active).svg" alt="" v-if="isWatchlistActive" />
            <img src="./../assets/images/Watchlist.svg" alt="" v-else />

            <p class="label menu-links" :style="[isWatchlistActive ? { color: 'red' } : {}]">Watchlist</p>
          </div>

          <div class="sections cursor-pointer" @click="$router.push('/options-watchlist')" v-if="userProfile && userProfile.profession == 'Retail Investor' && ($route.path == '/expert-past-strategy-options' || $route.path == '/options-watchlist')">
            <img src="./../assets/images/Watchlist (Active).svg" alt="" v-if="isWatchlistActive" />
            <img src="./../assets/images/Watchlist.svg" alt="" v-else />

            <p class="label menu-links" :style="[isWatchlistActive ? { color: 'red' } : {}]">Watchlist</p>
          </div>

          <div class="sections cursor-pointer" v-on:click="goToLink('/expert-list')" v-if="userProfile && userProfile.profession == 'Retail Investor'">
            <div>
              <span style="position: absolute">
                <img src="../assets/images/beta.svg" style="position: relative; bottom: 8px; left: 5px; width: 32px" alt="" />
              </span>
              <div>
                <img src="./../assets/images/ChatImages/My chat active.svg" style="width: 25px" alt="" v-if="isExpertChatListActive" />
                <img src="./../assets/images/ChatImages/Chat Icon (Not active).svg" style="width: 25px" alt="" v-else />
              </div>
            </div>
            <p class="label menu-links" :style="[isExpertChatListActive ? { color: 'red' } : {}]">Expert Chat</p>
          </div>

          <el-dropdown class="active-menu-link font-weight-600 segment-dropdown" v-if="userProfile.profession != 'Retail Investor'">
            <span class="el-dropdown-link capitalize">
              My Board
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <!-- <el-dropdown-item
                v-on:click.native="selectedMarketType == 'options' ? goToLink('/past-strategy-options') : goToLink('/past-recommendations')"
                :class="{
                  'active-menu-link': $router.path == '/past-strategy-options' || $router.path == '/past-recommendations',
                }"
              >
                My View
              </el-dropdown-item> -->
              <el-dropdown-item
                v-on:click.native="goToLink('/chat')"
                :class="{
                  'active-menu-link': $router.path == '/chat',
                }"
              >
                My Chat
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>

        </div>
      </div>
    </div>

    <!-- Sidebar Background Overlay -->
<div id="sideBarBackground" class=""></div>

 <div
      class="sideBar"
      style="position: fixed; left: -260px; top: 0; width: 260px; height: 100vh; background: #fff; z-index: 9999; transition: left 0.3s ease-in-out; overflow-y: auto;"
    >
      <div style="padding: 10px; border-bottom: 1px solid #e0e0e0;">
        <img src="@/assets/images/logo/logo1.png" alt="StockAnts Logo" style="width: 180px;" />
      </div>
      <div style="padding: 20px; display: flex; align-items: center; border-bottom: 1px solid #e0e0e0;" @click="goToLink('/profile-update')">
        <img
           :src="profile_pic" v-if="userProfile.picture"
          alt="User"
          style="width: 40px; height: 40px; border-radius: 50%; object-fit: cover; margin-right: 10px;"
        />
        <div style="flex: 1;">
          <div style="font-weight: bold; font-size: 14px;">
            {{ userProfile && userProfile.full_name ? userProfile.full_name : '' }}
          </div>
          <div style="font-size: 12px; color: gray;">
            {{ userProfile && userProfile.role ? userProfile.role : 'Analyst' }}
            <span style="color: #1890ff; margin-left: 5px;">✔</span>
          </div>
        </div>
        <i class="el-icon-arrow-right"></i>
      </div>
   <div>
  <p class="menu-item" @click="goToLink('/expert-list')">Expert Chat</p>
  <p class="menu-item" @click="goToLink('/chat')">My Chat</p>
  <p class="menu-item" @click="goToLink('/pricing')">Plans</p>
</div>
      <div style="position: absolute; bottom: 10px; text-align: center; margin-left: 20px;">
        <p class="cursor-pointer" @click="logOut()" style="color: #3f51b5; font-weight: 500;">Logout</p>
      </div>
    </div>
  </div>
</template>
<script>
import { EventBus } from '../eventBus';
import { serverAddr, serverHostName } from '../networkConfig';
import { screenSize } from '../mixins/ScreenSize';
import { loginNetworkCallBack } from '../mixins/login.NetworkCallback';
import { updateProfileNetworkCallBack } from '../mixins/UpdateProfile.NetworkCallBack';
import moment from 'moment';

export default {
  name: 'MobileNavContainer',
  mixins: [updateProfileNetworkCallBack, loginNetworkCallBack, screenSize],
  props: ['page_title'],
  data() {
    return {
      pdfPath: serverHostName + '/Media/important_doc/Stockantscompliancenewgcl.pdf',
      isDesktopSideBarOpen: true,
      isMobileSideBarOpen: false,
      changeProfessionDialog: false,
      isHomePageActive: false,
      isMarketPageActive: false,
      isGiveRecoPageActive: false,
      isMyDashboardSectionActive: false,
      isExpertChatListActive: false,
      isExpertSectionActive: false,
      isExpertSectionActive2: false,
      isMyViewSectionActive: false,
      isStockAntsTermsSectionActive: false,
      isMoreSectionActive: false,
      isPricingSectionActive: false,
      isMyChatActive: false,
      isEFSSectionActive: false,
      isTradingActive: false,
      isMoreActive: false,
      isLandingPageActive: false,
      isWatchlistActive: false,
      isPopoverVisible: false,
      popoverVisible: false,
      isExpertBuzzActive: false,
      notifications: [],
      tradeNotifications: [],
      followNotifications: [],
      activeName: 'all',
      showAllDialog: false,
      allNotificationsContent: '',
      profile_pic: require('../assets/images/navBar/avatar.jpg'),
      isUserLoggedIn: localStorage.getItem('token') ? true : false,
      moment: moment,
      userProfile: {},
      selectedMarketType: localStorage.getItem('market_type') ? localStorage.getItem('market_type') : 'equity',
      currentUrl: localStorage.getItem('currentUrl') ? localStorage.getItem('currentUrl') : window.location.href,
      websiteUserType: localStorage.getItem('websiteUserType') ? JSON.parse(localStorage.getItem('websiteUserType')) : {},
      currentEnvironment: {},
      paytmSource: '',
      serverHostName: serverHostName,
      pagination: {
        current_page: 1, // Current page
        total_entries: 0, // Total number of entries
        page_size: 5, // Number of items per page
        total_pages: 0, // Total number of pages
        previous_page_number: null, // Previous page number
        next_page_number: null, // Next page number
      },
      upstoxAccessToken: '',
      redirectUrl: 'https://uat-upstox.stockants.com/',
      isAdmin: false,
      isApiLoading: false,
    };
  },
  beforeCreate() {
    if (localStorage.getItem('profile')) {
      setTimeout(() => {
        var websiteUserType = localStorage.getItem('websiteUserType') ? JSON.parse(localStorage.getItem('websiteUserType')) : {};
        var userProfile = JSON.parse(localStorage.getItem('profile'));

        var internalTeamList = ['krishaa0801@gmail.com', 'joshiakshay719@gmail.com', 'fegde.mayur@gmail.com', 'snehalvpatil25@gmail.com', 'sumittarkas0001@gmail.com', 'bid.pallavi@gmail.com', 'pallavi.bid@stockants.com', 'bhushanm705811@gmail.com', 'admin@stockants.com', 'sumittarkas001@gmail.com', 'satavchetan08@gmail.com', 'amanm3047@gmail.com'];

        userProfile.email = userProfile.email.toLowerCase();

        if (websiteUserType && websiteUserType.userType == 'stockAnts' && internalTeamList.includes(userProfile.email)) {
          this.isAdmin = true;
        }
      }, 0);
    }
  },

  mounted() {
    if (this.$route.query.filter == 'followed stocks' || this.$route.query.filter == 'followed strategies') {
      this.isWatchlistActive = true;
    }

    if (localStorage.getItem('profile')) {
      this.userProfile = JSON.parse(localStorage.getItem('profile'));
    }

     if (this.userProfile && this.userProfile.picture) {
      this.profile_pic = serverHostName + this.userProfile.picture;
    }

    if (localStorage.getItem('paytmSource')) {
      this.paytmSource = localStorage.getItem('paytmSource');
    }

    this.checkActiveRoutePath(); //checks active route path and set actives top nav menu bar's links active

    if (this.userProfile && this.userProfile.picture) {
      this.profile_pic = serverHostName + this.userProfile.picture;
    }

    // Fetch all localStorage keys when the component is mounted
    this.getAllLocalStorageKeys();

    if (!localStorage.getItem('currentUrl') || this.userProfile) {
      this.selectUserType();
    }

    // get currentEnvironment details
    // Delay fetching the local storage value to ensure it has been set

    if (localStorage.getItem('currentEnvironment')) {
      this.currentEnvironment = JSON.parse(localStorage.getItem('currentEnvironment'));
    }

    // this.userProfile.utm_source = 'Almondz'

    EventBus.$on('profilePic', (data) => {
      this.profile_pic = serverHostName + data;
    });

    EventBus.$on('mobileSideBarIsClosed', (data) => {
      this.isMobileSideBarOpen = data;
      this.isDesktopSideBarOpen = data;
    });

    EventBus.$on('userData', (data) => {
      this.userProfile = data;
    });

    EventBus.$on('toggleButtonLoading', (isLoading) => {
      this.isApiLoading = isLoading;
    });

    if (localStorage.getItem('token')) {
      this.upstoxAccessToken = localStorage.getItem('token');
    }

    this.checkSelectedSegment();
    // this.getNotifications();
  },

  methods: {
     goToLink(path) {
    if (this.$route.path !== path) {
      this.$router.push(path);
    }
     this.closeSidebar();
  },
    getAllLocalStorageKeys() {
      const key = 'currentEnvironment';
      const value = localStorage.getItem(key);
      if (value) {
        this.currentEnvironment = JSON.parse(value);
      }
    },

    goToDematLink(link) {
      window.open(link, '_blank');
    },

    populateOrderDataAndSubmit() {
      const orders = [
        {
          quantity: 1,
          product: 'D',
          validity: 'DAY',
          price: 0,
          instrument_token: 'NSE_EQ|INE848E01016',
          order_type: 'MARKET',
          transaction_type: 'BUY',
          disclosed_quantity: 0,
          is_amo: false,
        },
        {
          quantity: 1,
          product: 'D',
          validity: 'DAY',
          price: 0,
          instrument_token: 'NSE_EQ|INE848E01016',
          order_type: 'MARKET',
          transaction_type: 'SELL',
          disclosed_quantity: 0,
          is_amo: false,
        },
        {
          quantity: 1,
          product: 'D',
          validity: 'DAY',
          price: 152.5,
          instrument_token: 'NSE_EQ|INE848E01016',
          order_type: 'LIMIT',
          transaction_type: 'BUY',
          disclosed_quantity: 0,
          is_amo: false,
        },
      ];

      this.orderData = JSON.stringify(orders);
      this.$refs.uplinkForm.submit();
    },

    backToPrevious() {
      window.history.back();
    },
    filterWatchList(currentClick) {
      if (!this.isWatchlistActive && currentClick == 'watchlist') {
        this.isWatchlistActive = true;
        EventBus.$emit('emitWatchListFilters', true);
        EventBus.$emit('toggleButtonLoading', true); // Notify expertView to block the button
      } else if (currentClick == 'expert view') {
        this.isWatchlistActive = false;
        EventBus.$emit('emitWatchListFilters', true);
        EventBus.$emit('toggleButtonLoading', true); // Notify expertView to block the button
      }
    },
    goToPaytmMoney() {
      window.dispatchEvent(new Event('goBackToPaytmMoney'));
    },
    checkSelectedSegment() {
      var segmentRoute = this.$route.path;

      if (segmentRoute == '/expert-past-strategy-options' || segmentRoute == '/past-strategy-options') {
        this.selectMarketType('options', segmentRoute);
      } else if (segmentRoute == '/experts-past-recommendations' || segmentRoute == '/past-recommendations') {
        this.selectMarketType('equity', segmentRoute);
      }
    },
    goToHome() {
      // this.$router.push("/retail-investors");
    },

    selectMarketType(market_type, segmentRoute) {
      localStorage.setItem('market_type', market_type);
      this.selectedMarketType = market_type;

      if (this.selectedMarketType == 'options' && !segmentRoute) {
        if (this.$route.path == '/upload-recommendation') {
          this.$router.push('/publish-recommendation-options');
        } else if (this.$route.path == '/past-recommendations') {
          this.$router.push('/past-strategy-options');
        } else {
          this.$router.push('/expert-past-strategy-options');
        }
      } else if (this.selectedMarketType == 'equity' && !segmentRoute) {
        if (this.$route.path == '/publish-recommendation-options') {
          this.$router.push('/upload-recommendation');
        } else if (this.$route.path == '/past-strategy-options') {
          this.$router.push('/past-recommendations');
        } else {
          this.$router.push('/data-categorisation');
        }
      }
      this.$store.commit('commitMarketSegment', market_type);
    },
    //on route match sets active nav link e.g. route is /upload-recommendation nav links
    checkActiveRoutePath() {
      if (this.$router.currentRoute.path == '/upload-recommendation' || this.$router.currentRoute.path == '/upload-long-term-reco-link' || this.$router.currentRoute.path == '/publish-recommendation-options') {
        this.isGiveRecoPageActive = true;
      } else if (this.$router.currentRoute.path == '/experts-past-recommendations' || this.$router.currentRoute.path == '/data-categorisation' || this.$router.currentRoute.path == '/other-expert-long-term-reco' || this.$router.currentRoute.path == '/other-expert-short-term-accuracy-graph' || this.$router.currentRoute.path == '/other-expert-long-term-accuracy-graph' || this.$router.currentRoute.path == '/other-expert-short-term-performance' || this.$router.currentRoute.path == '/other-expert-long-term-performance' || this.$router.currentRoute.path == '/expert-past-strategy-options') {
        this.isExpertSectionActive = true;
      } else if (this.$router.currentRoute.path == '/dashboard') {
        this.isHomePageActive = true;
        this.isMoreActive = true;
      } else if (this.$router.currentRoute.path == '/pricing') {
        this.isPricingSectionActive = true;
      } else if (this.$router.currentRoute.path == '/expert-list') {
        this.isExpertChatListActive = true;
      } else if (this.$router.currentRoute.path == '/my-account' || this.$router.currentRoute.path == '/profile-update' || this.$router.currentRoute.path == '/refer&earn' || this.$router.currentRoute.path == '/dashboard') {
        this.isMoreActive = true;
      } else if (this.$router.currentRoute.path == '/') {
        this.isLandingPageActive = true;
      } else if (this.$router.currentRoute.path == '/chat') {
        this.isMyChatActive = true;
      }
    },

    goToProfile() {
      this.changeProfessionDialog = true;
      if (this.$route.name == 'dashboard') {
        var expertHubSection = document.getElementById('expertHubSection');
        var homePageSideBar = document.getElementById('scroll');
        expertHubSection.style.zIndex = '0';
        homePageSideBar.style.zIndex = '0';
      }
    },

    changeProfession(profession) {
      serverAddr
        .post('/auth/v1/profile', {
          profession: profession,
          // profession: "Retail Investor",
          email: this.userProfile.email,
          mobile: this.userProfile.mobile,
        })
        .then(this.updateProfileCallBack)
        .catch(function (error) {
          console.log(error);
        });
    },

    logOut() {
      serverAddr
        .post('/auth/v1/sign_out', {
          refresh_token: localStorage.getItem('refresh_token'),
        })
        .then(this.logoutUserNetworkCallBack)
        .catch(function (error) {
          console.log(error);

          localStorage.clear();
          this.$router.push('/');

          // to set state to it's initial state and clear vue store
          this.$store.commit('resetAllState');
          let body = document.getElementsByTagName('body')[0];
          body.style.overflow = 'auto';
        });
    },

    handlePopoverShow() {
      let MARK_AS_READ = true;
      this.getNotifications(MARK_AS_READ);
    },

    getNotifications(MARK_AS_READ) {
      const page = this.pagination.current_page;
      const pageSize = this.pagination.page_size;

      let notificationType = ''; // Initialize notification type variable

      // Notification type based on the active tab
      if (this.activeName === 'all') {
        notificationType = ''; // All notifications
      } else if (this.activeName === 'followed') {
        notificationType = 'followed'; // Followed notifications
      } else if (this.activeName === 'trade') {
        notificationType = 'trade'; // Trade notifications
      }

      serverAddr
        .get('/base/v1/notification_list', {
          params: {
            notification_type: notificationType, // Pass the determined notification type
            page: page,
            page_size: pageSize,
          },
        })
        .then((response) => {
          if (response.data.status) {
            this.$store.commit('commitNotificationsList', response.data);

            if (response.data.response && response.data.response.length) {
              let notifications = response.data.response;
              if (this.activeName === 'followed') {
                this.followNotifications = notifications;
              } else if (this.activeName === 'trade') {
                this.tradeNotifications = notifications;
              } else {
                this.notifications = notifications;
              }

              // Collect unread notification IDs
              let unreadNotificationIds = notifications.filter((notification) => !notification.is_read).map((notification) => notification.id);

              // Mark all unread notifications on the current page as read
              if (unreadNotificationIds.length && MARK_AS_READ) {
                this.markNotificationsAsRead(unreadNotificationIds);
              }

              // Update unread count and pagination
              this.$store.commit('storeUnreadCount', response.data.unread_notification_count);
              this.updatePagination(response.data.pagination_dict);
            }
          }
        })
        .catch((error) => {
          console.error('Error fetching notifications:', error);
        });
    },

    // methods for pagination handling
    updatePagination(paginationData) {
      this.pagination.total_entries = paginationData.total_entries;

      this.pagination.total_pages = paginationData.total_pages;

      this.pagination.previous_page_number = paginationData.previous_page_number;
      this.pagination.next_page_number = paginationData.next_page_number;
    },

    handleTabChange() {
      let MARK_AS_READ = true;

      this.pagination.current_page = 1; // Reset page number to 1
      this.getNotifications(MARK_AS_READ); // Fetch all notifications
    },

    handleSizeChange(val) {
      let MARK_AS_READ = true;

      this.pagination.page_size = val;
      this.getNotifications(MARK_AS_READ);
    },

    handleCurrentChange(val) {
      let MARK_AS_READ = true;

      this.pagination.current_page = val;
      this.getNotifications(MARK_AS_READ);
    },

    // api to mark notification as read
    markNotificationsAsRead(notificationIds) {
      serverAddr
        .patch(`/base/v1/notification_list`, {
          notification_ids: notificationIds,
        })
        .then((response) => {
          if (response.data.status) {
            // Assuming commitNotificationsList mutation updates the notification status
            this.$store.commit('commitNotificationsList', response.data);

            // Update the local state to mark notifications as read
            notificationIds.forEach((id) => {
              let index = this.notifications.findIndex((n) => n.id === id);

              if (index > 0) {
                this.notifications[index].is_read = true;
              }
            });

            this.unreadCount = 0;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    // filterNotifications() {
    //   this.tradeNotifications = this.notifications.filter(
    //     (notification) => notification.notification_type_str === "Trade"
    //   );

    //   this.followNotifications = this.notifications.filter(
    //     (notification) =>
    //       notification.notification_type_str === "EQ Follow" ||
    //       notification.notification_type_str === "OP Follow"
    //   );
    // },

    getTimestamp(createdDate) {
      const currentTime = new Date();
      const notificationTime = new Date(createdDate);
      const timeDiff = currentTime.getTime() - notificationTime.getTime();
      const seconds = Math.floor(timeDiff / 1000);
      const minutes = Math.floor(seconds / 60);
      const hours = Math.floor(minutes / 60);
      const days = Math.floor(hours / 24);

      if (days > 0) {
        return `${days}d`;
      } else if (hours > 0) {
        return `${hours}h`;
      } else if (minutes > 0) {
        return `${minutes}m`;
      } else {
        return `${seconds}s`;
      }
    },

    groupNotificationsByDate(notifications) {
      const grouped = {};
      const today = moment().startOf('day');
      const yesterday = moment().subtract(1, 'days').startOf('day');

      notifications.forEach((notification) => {
        let date;
        const notificationDate = moment(notification.created_date).startOf('day');

        if (notificationDate.isSame(today, 'day')) {
          date = 'Today';
        } else if (notificationDate.isSame(yesterday, 'day')) {
          date = 'Yesterday';
        } else {
          date = notificationDate.format('MMMM DD, YYYY');
        }

        if (!grouped[date]) {
          grouped[date] = [];
        }
        grouped[date].push(notification);
      });

      return Object.keys(grouped).map((date) => ({
        date,
        notifications: grouped[date],
      }));
    },

    // api integration for delete notifications
    clearAllNotifications() {
      serverAddr
        .delete('/base/v1/delete_notification', {})
        .then((response) => {
          // console.log('Notifications cleared successfully');
          this.notifications = [];
          // Reset unreadCount to 0
          this.unreadCount = 0;
        })
        .catch((error) => {
          console.error(error);
        });
    },

    handleMouseEnter(notification) {
      notification.isHovered = true; // Set indicate hover state
    },

    handleMouseLeave(notification) {
      notification.isHovered = false; // Reset hover state
    },

    goToLink(link) {
      if (link) {
        this.$router.push(link);
      }

      if (this.isWatchlistActive) {
        this.filterWatchList('expert view');
      }
    },

    goToTradePage() {
      if (this.isTradeVisible()) {
        this.$router.push('/trading');
      } else {
        if (this.websiteUserType.userType != 'broker') {
          this.$store.commit('commitBrokerLoginDialogVisibility', true);
        } else {
          this.$store.commit('commitSubscribPlanDialogVisibility', true);
        }
      }
    },

    getTradeHostDetails() {
      this.$store.commit('commitHybridBrokerLoginDialogVisibility', true);
    },

    toogleMobileSideNav() {
      this.isMobileSideBarOpen = !this.isMobileSideBarOpen;
      if (this.isMobileSideBarOpen) {
        this.openSideBarForMobile();
      } else {
        this.closeSideBarForMobile();
      }
    },

    openSideBarForMobile() {
      document.getElementById('sideBarBackground').setAttribute('class', 'activeSideBarBackground');
      document.getElementsByClassName('sideBar')[0].style.left = '0';
      document.getElementsByClassName('main')[0].style.width = '100%';
      document.getElementsByClassName('main')[0].style.marginLeft = '0px';
      let body = document.getElementsByTagName('body')[0];
      body.style.overflow = 'hidden';

      // to scroll sidenav to initial position
      var elmnt = document.getElementsByClassName('sideBar')[0];
      // scrollTo(elmnt, 0, 100);
      elmnt.scrollTop = 0;
    },

    closeSidebar() {
    const sidebar = document.querySelector('.sideBar');
    const overlay = document.getElementById('sideBarBackground');

    if (sidebar) sidebar.style.left = '-260px';
    if (overlay) overlay.classList.remove('active');
  },

    // stored in store boolean value---to open demo dialog
    openDemoDialog() {
      this.$store.commit('commitDialogVisibility', true);
    },

    // this method from close popover on Notification click
    closePopover() {
      this.popoverVisible = false;
      this.isPopoverVisible = false;
    },

    handleViewNotification(notification) {
      if (notification.redirect_url === 'Equity Followed' || notification.redirect_url === 'Options Followed') {
        if (this.$router.currentRoute.path !== '/experts-past-recommendations' && notification.redirect_url === 'Equity Followed') {
          this.$router.push('/experts-past-recommendations?filter=followed stocks');
          // /experts-past-recommendations?user_id=${this.$route.query.user_id}
        } else if (this.$router.currentRoute.path !== '/expert-past-strategy-options' && notification.redirect_url === 'Options Followed') {
          this.$router.push('/expert-past-strategy-options?filter=followed strategies');
        } else {
          this.filterWatchList('watchlist');
        }

        // this.filterWatchList("watchlist");
      } else if (notification.redirect_url === 'My Account') {
        // Redirect to /my-account
        this.$router.push('/my-account');
      } else if (notification.redirect_url === 'Profile Update') {
        // Redirect to /profile-update
        this.$router.push('/profile-update');
      } else if (notification.redirect_url === 'Access Code') {
        // Redirect to /my-account
        this.$router.push('/my-account');
      } else if (notification.redirect_url === 'Eq My View') {
        // Redirect to /my-account
        this.$router.push('/experts-past-recommendations');
      } else if (notification.redirect_url === 'Opt My View') {
        // Redirect to /my-account
        this.$router.push('/expert-past-strategy-options');
      } else if (notification.redirect_url === 'Plan Subscription') {
        // Redirect to /pricing
        this.$router.push('/my-account');
      } else if (notification.redirect_url === 'Orders') {
        // Redirect to /trading
        this.$router.push('/trading');
        this.$store.commit('commitTradeMenu', 'ORDERS');
      }

      if (!notification.is_read) {
        // Decrease unreadCount by 1
        this.unreadCount -= 1;

        // unreadCount doesn't go below 0
        if (this.unreadCount < 0) {
          this.unreadCount = 0;
        }
      }
      this.closePopover();
    },
  },

  created() {
    this.getNotifications(); // Fetch notifications when component is created
  },
  beforeDestroy() {
    EventBus.$off();
  },

  computed: {
    //returns stored user profile from local storage
    // userProfile() {
    //   return JSON.parse(localStorage.getItem("profile"));
    // },

    //returns subscribed plan details from local storage
    subscribedPlanDetails() {
      return JSON.parse(localStorage.getItem('plan_details'));
    },

    getNotificationsList() {
      return this.$store.state.notifications_list;
    },

    unreadCount: {
      get() {
        return this.$store.state.unreadNotificationCount;
      },
      set(value) {
        this.$store.commit('storeUnreadCount', value);
      },
    },

    groupedNotifications() {
      return this.groupNotificationsByDate(this.notifications);
    },
    groupedFollowedNotifications() {
      return this.groupNotificationsByDate(this.followNotifications);
    },
    groupedTradeNotifications() {
      return this.groupNotificationsByDate(this.tradeNotifications);
    },

    isPremiumUser() {
      // Check if userProfile exists and plan is Premium
      const planDetails = this.subscribedPlanDetails;
      return this.userProfile && planDetails && planDetails.plan === 'Premium';
    },

    getMarketSegment() {
      this.selectedMarketType = this.$store.state.market_segment;
      return this.$store.state.market_segment;
    },

    getChatPlanDetails() {
      return this.$store.state.chat_plan_details ? this.$store.state.chat_plan_details : JSON.parse(localStorage.getItem('chat_plan_details'));
    },
  },
};
</script>
<style lang="scss" scoped>
@import '../css/variable.scss';
@import '../css/common.scss';

.MobileNavContainer {
  position: fixed;
  top: 0;
  z-index: 2;
  width: 100%;

  .chat-btn {
    border: 1px solid #2488ff;
    color: #2488ff;
    padding: 3px 10px;
    font-size: 12px;
    margin-right: 8px;
    border-radius: 5px;
    font-weight: 500;
  }
}

// desktop nav css start
.fixedNavBar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #fff;
  height: 60px;
  padding: 20px 20px;
  position: fixed;
  width: 100%;
  z-index: 111;
  top: 0;
  box-sizing: border-box;
  box-shadow: 0px -2px 14px 0px #d6d6d6;
}

.menu-links {
  padding: 0 9px;
  font-size: 0.6rem;
  font-weight: 600;
  color: #777777;
}

.menu-links:hover {
  color: $primary-theme-color;
}

.active-menu-link {
  color: $primary-theme-color;
}

.logo {
  width: 160px;
  height: 100%;
  cursor: pointer;
  margin-right: 80px;
}

.menu-bar-items {
  font-size: 0.8rem !important;
}

.navbar-profile-pic-section {
  height: 30px;
  min-width: 30px;
  border-radius: 100%;
  background-color: #fff;
  padding: 2px;
  display: inline-block;
}

.profile-pic {
  object-fit: cover;
  border-radius: 100%;
}

.dashboard-profile-name {
  color: #414550;
  font-size: 0.9rem;
  font-weight: 300;
  margin: 0px 0px 0 10px;
}

.dashboard-profile-email {
  color: #fff;
  font-size: 0.8rem;
  margin: 0px 0px 0 0px;
  text-decoration: underline;
}

// mobile nav css start
.mobile-view-nav-container {
  display: flex;
  align-items: center;
  // justify-content: space-between;
  padding: 10px;
  height: 40px;
  background-color: #ffffff;

  .footer-nav {
    display: none;
    position: fixed;
    bottom: 0;
    padding: 10px 0 5px;
    left: 0;
    background-color: #ffff;
    width: 100%;
    box-shadow: 0px 0px 14px 1px #a3a3a3;

    .footer-inner {
      display: flex;
      justify-content: space-around;
      align-items: center;

      .sections {
        text-align: center;

        img {
          width: 23px;
          cursor: pointer;
        }

        img:hover {
          filter: brightness(0.5);
        }

        .label {
          margin: 3px 0;
          font-size: 0.8rem;
          color: #525050;
        }
      }
    }
  }
}

// css for email notification

.clear-button {
  position: absolute;
  text-decoration: none;
  top: 35px !important;
  right: 0;
  margin: 40px;
  float: right;
  z-index: 111;
}

.close-icon {
  position: absolute;
  top: 15px;
  right: 15px;
  cursor: pointer;
  font-size: 20px;
  color: #000;
}

.Notification-heading {
  margin-left: 15px;
}

.notification-icon {
  cursor: pointer;
  margin-left: 5px;
  margin-right: 7px;
}

.No-notification {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 30px;
  padding-bottom: 30px;
}

.group-day {
  margin-top: 5px;
  margin-bottom: 5px;
}

// for bell icon badge
.bell-icon-container {
  position: relative;
}

.badge {
  margin-right: 5px;
  position: absolute;
  // top: -5px;
  right: -8px;
  bottom: 15px;
  cursor: pointer;
  // padding: 2px !important
}

.custom-badge {
  font-size: 10px;
  font-weight: 800;
  padding: 2px;
}

.notification-container {
  font-weight: 600;
  font-size: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  border-top: 1px solid #dbdbdb;
  cursor: pointer;
  text-align: initial;
  // background-color: #e0eeff;
}

.notification-message {
  text-align: left;
}

.blue-dot {
  width: 8px;
  height: 8px;
  background-color: #2488ff;
  border-radius: 50%;
  // margin-left:5px;
  // margin-right:10px
}

.notification-container:hover {
  background-color: #f0f0f0;
}

.unread-notification {
  background-color: #e0eeff;
  /* Background color for unread notifications */
}

.read-notification {
  background-color: #f6f6f6;
  /* Background color for read notifications */
}

.logo-section {
  margin-right: 10px;
}

.notification-logo {
  width: 30px;
  height: auto;
}

.message-section {
  flex-grow: 1;
  width: 290px;
}

.view-button {
  padding: 2px 5px 2px 5px;
  background: rgba(255, 255, 255, 0);
  border: 1px solid #2488ff;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  cursor: pointer;
  border-radius: 5px;
  color: #2488ff;
  font-size: 14px;
  font-weight: 500;
  margin-left: 10px;
}

.notification-timestamp {
  color: #9d9d9d;
  padding: 5px;
  width: 25px;
  margin-left: 10px;
}

.navTitle {
  color: #767676;
  font-size: 1rem;
  line-height: 30px;
  padding: 0.625rem 0;
  font-weight: 300;
  margin-left: 1rem;
}

.nav-icon {
  width: 22px;
  display: block;
}

.nav-icon:after,
.nav-icon:before,
.nav-icon div {
  background-color: $secondary-theme-color;
  border-radius: 3px;
  content: '';
  display: block;
  height: 1px;
  margin: 5px 0;
  transition: all 0.2s ease-in-out;
}

.mobileToggleMenuBtn {
  height: 22px;
}

.menu-item {
  cursor: pointer;
  padding: 12px 20px;
  font-size: 0.8rem;
  color: #111112;
  transition: 0.3s;
  text-decoration: none;
  font-weight: 500;
  border-bottom: 1px solid #e4e6ec;
}

@media screen and (max-width: 1283px) {
  .fixedNavBar {
    display: none;
  }

  .mobile-view-nav-container {
    .footer-nav {
      display: block;
    }
  }
}

@media screen and (min-width: 1284px) {
  .mobileNavContainer {
    display: none;
  }
}

@media screen and (max-width: 480px) {
  .open-demat-account-btn {
    font-size: 8px !important;
    padding: 7px 10px;
    margin-right: 5px !important;
  }

  .notification-icon {
    width: 20px !important;
    height: 20px !important;
  }
}

@media screen and (max-width: 500px) {
  .logo {
    width: 100px !important;
  }

  .navTitle {
    font-size: 0.8rem;
  }

  .mobile-view-nav-container .footer-nav .footer-inner .sections {
    .label {
      font-size: 0.65rem;
    }

    img {
      width: 18px;
    }
  }
}
</style>
<style lang="scss">
@import '../css/variable.scss';
@import '../css/common.scss';

.MobileNavContainer {
  // .btn-theme-borderd{
  //   font-size: 12px;
  // }
}

.segment-dropdown i.el-icon-arrow-down.el-icon--right {
  color: #e72726 !important;
}

.expert-buzz-btn {
  background: linear-gradient(90deg, #2d2e8d 0%, #0c0d27 100%);
  color: #fff;
  border: none;
  font-size: 11px;
  font-weight: 700;
  padding: 6px 15px;
  border-radius: 50px;
  display: flex;
  align-items: center;
  gap: 10px;
  margin-right: 10px;
}

// .expert-buzz-btn:hover {
//  opacity: 0.9;
// }
.expert-buzz-btn img {
  width: 15px;
  height: 15px;
  object-fit: contain;
  margin-right: 5px;
}
.market-type-dropdown {
  background: #e72726;
  padding: 0px 0px 4px 4px;
  border-radius: 6px;
  margin-right: 6px;

  .active-menu-link {
    color: #ffff !important;
    font-weight: bolder;
  }

  .active-menu-link:hover {
    color: #ffff;
  }
}

.activeSideBarBackground {
  position: fixed;
  right: 0;
  left: 0;
  bottom: 0;
  top: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 11;
  min-height: 100vh;
}

.navbarContent {
  width: 100%;
  display: flex;
  align-items: center;
  // padding-bottom: 7px;
  margin-left: 0px;
}

.el-dropdown-menu__item:hover {
  color: $primary-theme-color !important;
}

.notification-divider {
  display: flex;
  font-size: 12px;

  img {
    margin-top: 5px;
  }
}

.notification-drawer {
  .el-dropdown-menu__item:hover {
    color: #000 !important;
    background: #fff;
  }

  .title {
    color: #000;
    font-weight: 600;
    cursor: text;
  }

  .title:hover {
    background-color: #fff;
  }

  .notification-menu-item,
  .notification-title {
    font-size: 0.8rem;
  }
}

.notification-count {
  .el-badge__content.is-fixed {
    right: 21px;
  }

  .el-badge__content {
    font-size: 10px;
    line-height: 15px;
    font-weight: 800 !important;
    border-color: #f56c6c;
    height: 10px !important;
  }
}

.publish-btn {
  height: 22px;
  line-height: 5;
  display: flex;
  align-items: center;
  font-weight: 600;
  font-size: 10px;
  outline: none;
  border-radius: 6px;
  color: #fff !important;
  border: 1px solid #e72726;
  background: #e72726;
  margin: 0 5px;
}

.notification-popover {
  width: 450px;
  // height: 100%;
  padding: 10px;
  border-radius: 20px;
  box-shadow: 0px 0px 10px 5px rgba(0, 0, 0, 0.1);

  .el-tabs__item {
    padding: 0 20px !important;
  }
}

@media screen and (max-width: 1280px) {
  .notification-popover {
    width: calc(100% - 30px);
    height: calc(100% - 135px);
  }
}

.professionChangeDialog {
  .cancel-btn {
    background-color: transparent;
  }

  .el-dialog {
    border-radius: 10px;
    width: 400px;
  }

  .el-dialog--center .el-dialog__body {
    word-break: normal;
  }

  @media screen and (max-width: 420px) {
    .el-dialog {
      width: 90%;
    }
  }
}

@media screen and (max-width: 500px) {
  .MobileNavContainer {
    .el-dropdown {
      font-size: 0.65rem !important;
    }
  }
  .el-dropdown-menu__item {
    font-size: 0.65rem !important;
  }
}
</style>